import React, { Component } from 'react';
import Dialog from '../../../../commonModules/interface/Dialog.jsx';
import SingleProduct from '../products/SingleProduct.jsx';
import { connect } from 'react-redux';
import { BreadCrumb, ListLayout, TableLayout } from '../containers/Layout';
import SingleShop from '../shops/SingleShop.jsx';
import { TableRow, TableCell, TableBody, TableHead } from '@material-ui/core';
import InputText from '../../../../commonModules/interface/form-input-inline.jsx';


const translate = {
    "new": "Comme Neuf",
    "very_good": "Très bien",
    "good": "Bien",
    "bad": "Mauvais",
}

class Return extends Component {
    state = {
        search:"",
        searchClass:"custom-search",
        //Dialog
        dialogHistory:false,
        dialogNew:false,

        //stock, used for history
        history_single:{
            product_id: "",
            shop_id: "",
            name: "",
        },
        singleProd:{},
        singleShop:{},

        breadcrumb: "",
        showSingle: false,
        
        sortQty:"",
        
    }
    normalizeStr = (str) => {// remove accent and lower case str
        str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
        return str
    }
    // LISTS & TABLES
    createStockList(){
        const { SHOPS, PRODUCTS, OCCASION, RETURNS } = this.props
        const { search, sortQty } = this.state

        let searching = search ? this.normalizeStr(search) : ""
        let list = Object.keys(OCCASION)

        console.log('====================================');
        console.log({list});
        console.log('====================================');
        
        let filteredList = list.filter( stockID => {
            const stock = OCCASION[stockID]
            let product = PRODUCTS[stock.product_ref]
            let shop = SHOPS[stock.shop_id]

            if(!searching){
                return true
            } else {
                const productName = product ? this.normalizeStr(product.name) : ""
                const productRef = product ? this.normalizeStr(product.ref) : ""
                const productType = product ? this.normalizeStr(product.type) : ""
                const productBrand = product ? this.normalizeStr(product.marque) : ""
                const shopName = shop ? this.normalizeStr(shop.name) : ""
                const shopCity = shop ? this.normalizeStr(shop.city) : ""
                const shopCountry = shop ? this.normalizeStr(shop.country) : ""
                return ( 
                    
                    productName.indexOf(searching) !== -1 ||
                    productRef.indexOf(searching) !== -1 ||
                    productType.indexOf(searching) !== -1 ||
                    productBrand.indexOf(searching) !== -1 ||
                    shopName.indexOf(searching) !== -1 ||
                    shopCity.indexOf(searching) !== -1 ||
                    shopCountry.indexOf(searching) !== -1 
                )

            }
            
        })
        // sort
        if( sortQty === 'asc' ){
            filteredList.sort( (stock1, stock2) => OCCASION[stock1].quantity - OCCASION[stock2].quantity  )
        } else if ( sortQty === 'desc') {
            filteredList.sort( (stock1, stock2) => OCCASION[stock2].quantity - OCCASION[stock1].quantity  )
        }

        console.log('====================================');
        console.log({filteredList});
        console.log('====================================');

        return filteredList.map( stockID => {
            const stock = OCCASION[stockID]
            const product = PRODUCTS[stock.product_ref]
            const shop = SHOPS[stock.shop_id]

            if( stock.quantity > 0 && product ){      
                let prodName = product.name
                let prodShortName = (prodName.length > 40 ? (prodName.substring(0, 40) + "...") : prodName)
                return (        
                    <TableRow key={stockID}>
                        <TableCell>{stock && stock.return_product_id.substring(0,8) }</TableCell>
                        <TableCell>
                            <a href="#" 
                                onClick={ () => this.handleSingleProd(product) } 
                                title={prodName}
                            >
                                {prodShortName} - {product.marque}
                            </a>
                        </TableCell>
                        <TableCell>{RETURNS[stockID] && translate[RETURNS[stockID].product_state]}</TableCell>
                        <TableCell>
                            <a href="#" onClick={ () => this.handleSingleShop(shop) }>
                                {shop && shop.name}
                            </a>
                        </TableCell>
                        <TableCell>{stock.quantity}</TableCell>
                    </TableRow>
                )
            }
        })
    }
   
// CLEAR & DISPLAY
    handleClose = () => {
        this.setState({
            dialogHistory:false,
            dialogNew:false,
            showSingleProd: false,
            showSingleShop: false,
            breadcrumb: "",
            history_single:{
                name:"",
                product_id:"",
                shop_id:"",
            }
        });
    }
    handleSingleProd = (prod) => {
        this.setState({
            breadcrumb: prod.name,
            singleProd:prod,
            showSingleProd: true
        })
    }
    handleSingleShop = (shop) => {
        this.setState({
            breadcrumb: shop.name,
            singleShop:shop,
            showSingleShop: true
        })

    }
    render() {
        console.log("[STATE] stocks ",this.state);
        console.log("[props] stocks ",this.props);

        const { OCCASION } = this.props

        return (
            <div>
                <BreadCrumb breadcrumb={ this.state.breadcrumb } title="Inventaire" back={this.handleClose} />    
                
                {this.state.showSingleShop &&
                    <SingleShop shop={this.state.singleShop} {...this.props} occasion />    
                }       
                {this.state.showSingleProd &&
                    <SingleProduct product={this.state.singleProd} {...this.props} occasion />
                }
                {!this.state.showSingleShop && !this.state.showSingleProd &&
                
                    <div >
                        <InputText 
                            // className={this.state.searchClass} 
                            // type="text" 
                            name="search" 
                            value={this.state.search} 
                            placeholder="Rechercher par magasin, produit, marque ..." 
                            onChange={ (e)=> this.setState({search: e.target.value})} 
                        />
                        
                        {/* <ul className="tab-nav text-center" style={{
                            overflow: "auto" }}>
                            <li 
                                onClick={ () => this.setState({ stockList: "AVAILABLE" }) } 
                                className={this.state.stockList === "AVAILABLE" ? "active":""}>
                                <a href="#" >Disponible</a>
                            </li>
                            <li 
                                onClick={ () => this.setState({ stockList: "OUT" }) } 
                                className={this.state.stockList === "OUT" ? "active":""}>
                                <a href="#" >VENDUS</a>
                            </li>             

                        </ul> */}
                        <ListLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ID Retour</TableCell>
                                    <TableCell>Produit</TableCell>
                                    <TableCell>Etat</TableCell>
                                    <TableCell>Shop</TableCell>
                                    
                                    <TableCell 
                                        className={"sorting" + this.state.sortQty} 
                                        onClick={() => this.setState({ 
                                            sortQty: (this.state.sortQty === 'asc' || this.state.sortQty === '' ? 'desc' : 'asc' )})
                                        }>
                                        Quantité
                                    </TableCell>
                                    {/* <TableCell>Historique</TableCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Object.keys(OCCASION).length > 0  && this.createStockList()}
                                
                                { Object.keys(OCCASION).length === 0  && 
                                <TableRow>
                                    <TableCell colSpan="4">
                                        <div className="text-center">
                                            <h5>Pas de Stock</h5> 
                                            {/* Allez dans l'onglet <b className="onglet">"Achats"</b> Pour Créer un nouveau Stock */}
                                        </div>
                                    </TableCell>
                                </TableRow>
                                }
                            </TableBody>
                        </ListLayout> 
                    </div>
                }
            </div>
        );
    }
}
function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        RETURNS: state.inventory.returns,
        PRODUCTS: state.inventory.products,
        SHOPS: state.inventory.shops,
        OCCASION: state.inventory.stocks.OCCASION,
    }
}

export default connect(mapStateToProps )(Return);